import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import { COLORS } from "./theme";
import LearnLink from "./LearnLink";

// Pillar → most-central concept page. Picked so the explainer answers
// the obvious next question ("how is THIS pillar scored?").
const PILLAR_SLUG = {
  profitability: "ebitda-margin",
  liquidity: "quick-ratio",
  solvency: "dscr",
  efficiency: "cash-conversion-cycle",
};

export default function SubScoresCard({ subscores }) {
  const order = ["profitability", "liquidity", "solvency", "efficiency"];
  return (
    <Card className="lg:col-span-4 bg-white border-[#E5E0D8] shadow-none" data-testid="subscores-card">
      <CardHeader className="pb-2">
        <CardDescription className="text-xs uppercase tracking-[0.18em] text-[#5C665D]">Pillar scores</CardDescription>
        <CardTitle className="font-serif-display text-2xl text-[#1F382E]">Where you're strong, where you're not.</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4 pt-3">
        {order.map((key) => {
          const v = subscores[key];
          const pct = Math.max(0, Math.min(100, Number(v || 0)));
          const slug = PILLAR_SLUG[key];
          return (
            <div key={key} data-testid={`subscore-${key}`}>
              <div className="flex items-center justify-between text-sm gap-2">
                <span className="capitalize text-[#1A1A1A] flex items-center gap-2 min-w-0">
                  <span className="truncate">{key}</span>
                  {slug && (
                    <LearnLink
                      slug={slug}
                      label="30s"
                      source={`subscore_${key}`}
                      variant="inline"
                    />
                  )}
                </span>
                <span className="tabular-nums text-[#1F382E] font-medium shrink-0">{v == null ? "—" : `${v}`}</span>
              </div>
              <div className="mt-2 h-1.5 w-full bg-[#E5E0D8] rounded-full overflow-hidden">
                <div
                  className="h-full rounded-full transition-all duration-700"
                  style={{ width: `${pct}%`, background: pct >= 70 ? COLORS.success : pct >= 45 ? COLORS.warning : COLORS.danger }}
                />
              </div>
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
}
